module.exports = {"API_URL":"https://api-rrhh.yaracuy.gob.ve","APP_DEVMOD":true}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 157
// module chunks = 1